"use strict";

var _interopRequireDefault3 = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault3(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault3(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault3(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault3(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault3(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault3(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault3(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault3(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault3(require("@babel/runtime/helpers/defineProperty"));

var _interopRequireDefault2 = _interopRequireDefault3(require("@babel/runtime/helpers/interopRequireDefault"));

var _autobindDecorator = _interopRequireDefault3(require("autobind-decorator"));

var _events = require("../../utils/events");

var _classnames = _interopRequireDefault3(require("classnames"));

var _filterDOMProps = _interopRequireDefault3(require("../../utils/filterDOMProps"));

var _focusRing = _interopRequireDefault3(require("../../utils/focusRing"));

var _intl = require("../../utils/intl");

var _OverlayTrigger = _interopRequireDefault3(require("../../OverlayTrigger"));

var _propTypes = _interopRequireDefault3(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Tooltip = _interopRequireDefault3(require("../../Tooltip"));

var _VisuallyHidden = _interopRequireDefault3(require("../../VisuallyHidden"));

require("../style/index.css");

var _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var intlMessages = {
  "cs-CZ": (0, _interopRequireDefault2["default"])(require("./../intl/cs-CZ.json"))["default"],
  "da-DK": (0, _interopRequireDefault2["default"])(require("./../intl/da-DK.json"))["default"],
  "de-DE": (0, _interopRequireDefault2["default"])(require("./../intl/de-DE.json"))["default"],
  "en-US": (0, _interopRequireDefault2["default"])(require("./../intl/en-US.json"))["default"],
  "es-ES": (0, _interopRequireDefault2["default"])(require("./../intl/es-ES.json"))["default"],
  "fi-FI": (0, _interopRequireDefault2["default"])(require("./../intl/fi-FI.json"))["default"],
  "fr-FR": (0, _interopRequireDefault2["default"])(require("./../intl/fr-FR.json"))["default"],
  "hu-HU": (0, _interopRequireDefault2["default"])(require("./../intl/hu-HU.json"))["default"],
  "it-IT": (0, _interopRequireDefault2["default"])(require("./../intl/it-IT.json"))["default"],
  "ja-JP": (0, _interopRequireDefault2["default"])(require("./../intl/ja-JP.json"))["default"],
  "ko-KR": (0, _interopRequireDefault2["default"])(require("./../intl/ko-KR.json"))["default"],
  "nb-NO": (0, _interopRequireDefault2["default"])(require("./../intl/nb-NO.json"))["default"],
  "nl-NL": (0, _interopRequireDefault2["default"])(require("./../intl/nl-NL.json"))["default"],
  "pl-PL": (0, _interopRequireDefault2["default"])(require("./../intl/pl-PL.json"))["default"],
  "pt-BR": (0, _interopRequireDefault2["default"])(require("./../intl/pt-BR.json"))["default"],
  "ru-RU": (0, _interopRequireDefault2["default"])(require("./../intl/ru-RU.json"))["default"],
  "sv-SE": (0, _interopRequireDefault2["default"])(require("./../intl/sv-SE.json"))["default"],
  "tr-TR": (0, _interopRequireDefault2["default"])(require("./../intl/tr-TR.json"))["default"],
  "uk-UA": (0, _interopRequireDefault2["default"])(require("./../intl/uk-UA.json"))["default"],
  "zh-CN": (0, _interopRequireDefault2["default"])(require("./../intl/zh-CN.json"))["default"],
  "zh-TW": (0, _interopRequireDefault2["default"])(require("./../intl/zh-TW.json"))["default"]
};
var formatMessage = (0, _intl.messageFormatter)(intlMessages);
var SMALL = 'S';
/**
 * An individual Step in a StepList
 */

var Step = (0, _autobindDecorator["default"])(_class = (0, _focusRing["default"])(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Step, _Component);

  function Step() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Step);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Step)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      focused: false
    });
    return _this;
  }

  (0, _createClass2["default"])(Step, [{
    key: "showTooltip",
    value: function showTooltip() {
      if (!this._tooltipHidden) {
        this.setState({
          focused: true
        });
      }
    }
  }, {
    key: "hideTooltip",
    value: function hideTooltip(event) {
      this.setState({
        focused: false
      });
      this._tooltipHidden = event && event.type !== 'blur';
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          complete = _this$props.complete,
          selected = _this$props.selected,
          size = _this$props.size,
          disabled = _this$props.disabled,
          index = _this$props.index,
          ariaSetSize = _this$props.ariaSetSize,
          onFocus = _this$props.onFocus,
          onBlur = _this$props.onBlur,
          ariaLabel = _this$props['aria-label'],
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props, ["children", "className", "complete", "selected", "size", "disabled", "index", "ariaSetSize", "onFocus", "onBlur", "aria-label"]);
      var focused = this.state.focused;
      var stateString = formatMessage('not completed');

      if (selected) {
        stateString = formatMessage('current');
      } else if (complete) {
        stateString = formatMessage('completed');
      }

      var domLinkProps = _objectSpread({}, (0, _filterDOMProps["default"])(otherProps));

      if (selected) {
        domLinkProps['aria-current'] = 'step'; // when item is focused, we want to announce state changes assertively

        if (focused) {
          domLinkProps['aria-live'] = 'assertive';
          domLinkProps['aria-atomic'] = 'true';
          domLinkProps['aria-relevant'] = 'text';
        }
      }

      var whenDisabledDomItemProps = {};

      if (disabled) {
        // when disabled, props that would normally get applied to the link, like aria-current, 
        // should be applied to the list item itself.
        whenDisabledDomItemProps = _objectSpread({}, domLinkProps); // remove event handlers and tabIndex when the step is disabled

        delete whenDisabledDomItemProps.onClick;
        delete whenDisabledDomItemProps.onFocus;
        delete whenDisabledDomItemProps.onKeyDown;
        delete whenDisabledDomItemProps.onKeyUp;
        delete whenDisabledDomItemProps.onMouseDown;
        delete whenDisabledDomItemProps.tabIndex;
      }

      var renderItemContent = function renderItemContent() {
        var isSmall = size === SMALL;
        var labelAndMarker = [!isSmall && children && _react["default"].createElement("div", {
          className: "spectrum-Steplist-label",
          key: "label-".concat(index)
        }, _react["default"].createElement(_VisuallyHidden["default"], null, stateString), children), _react["default"].createElement("span", {
          className: "spectrum-Steplist-markerContainer",
          key: "marker-".concat(index)
        }, isSmall && children ? _react["default"].createElement(_OverlayTrigger["default"], {
          placement: "top",
          show: focused || undefined,
          onHide: _this2.hideTooltip
        }, _react["default"].createElement("span", {
          className: "spectrum-Steplist-marker"
        }, _react["default"].createElement(_VisuallyHidden["default"], null, stateString, children)), _react["default"].createElement(_Tooltip["default"], {
          open: true,
          className: "spectrum-Steplist-tooltip"
        }, children)) : _react["default"].createElement("span", {
          className: "spectrum-Steplist-marker"
        }, _react["default"].createElement(_VisuallyHidden["default"], null, stateString, ariaLabel)))];

        if (disabled) {
          return labelAndMarker;
        }

        return _react["default"].createElement("a", (0, _extends2["default"])({
          className: (0, _classnames["default"])('spectrum-Steplist-link'),
          role: "link"
        }, domLinkProps, {
          onFocus: (0, _events.chain)(_this2.showTooltip, onFocus),
          onBlur: (0, _events.chain)(_this2.hideTooltip, onBlur)
        }), labelAndMarker);
      };

      return _react["default"].createElement("div", (0, _extends2["default"])({
        className: (0, _classnames["default"])(className, 'spectrum-Steplist-item', {
          'is-complete': complete
        }, {
          'is-disabled': disabled
        }, {
          'is-selected': selected
        }, {
          'is-focused': focused
        }),
        role: "listitem",
        "aria-posinset": index + 1,
        "aria-setsize": ariaSetSize
      }, whenDisabledDomItemProps), renderItemContent(), _react["default"].createElement("span", {
        className: "spectrum-Steplist-segment"
      }));
    }
  }]);
  return Step;
}(_react.Component), (0, _defineProperty2["default"])(_class2, "displayName", 'Step'), (0, _defineProperty2["default"])(_class2, "propTypes", {
  /** Class to add to the step */
  className: _propTypes["default"].string,

  /** Whether the current step is completed */
  complete: _propTypes["default"].bool,

  /** Whether the current step is selected */
  selected: _propTypes["default"].bool,

  /** Define the size of the step */
  size: _propTypes["default"].oneOf(['S', 'L'])
}), _temp)) || _class) || _class;

exports["default"] = Step;